import { useState, useEffect,useRef, useContext } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { delimitationService } from "../../services/DelimitationService";
import { changeLang } from "../../componets/Language/ChangeLang";
import { DermacationLevels, permissionLookUp } from "../../constants";
import { AppDB } from "../../App";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { ProgressSpinner } from "primereact/progressspinner";
import ScreenLoader from "../../componets/ScreenLoader";
import { authenticationService } from "../../services/AuthenticationService";
import GenericUploadFileTable from "../../componets/GenericUploadFileTable";

import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { Tag } from "primereact/tag";
import { formatDateTime } from "../../config/Config";
import GenericFileCapture from "../../componets/GenericFileCapture";

const DEMARCATION_LEVELS = [
    { id: 1, name: "District" },
    { id: 2, name: "Constituency" },
    { id: 3, name: "Voting District" },
    { id: 4, name: "Voting Centre" },
    { id: 5, name: "Village" }
];


export const DelimitationCorrectionManagement = () => {
    const fileInputRef = useRef(null);
    const { permission, toast, lookUp } = useContext(AppDB);

    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Form state
    const [comment, setComment] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [filePreviewRows, setFilePreviewRows] = useState([]);
    const [fileBytes, setFileBytes] = useState(null);
    const [selectedStructure, setSelectedStructure] = useState(null);

    // View states
    const [showDocumentDialog, setShowDocumentDialog] = useState(false);
    const [showRecordsDialog, setShowRecordsDialog] = useState(false);
    const [selectedCorrection, setSelectedCorrection] = useState(null);
    const [correctionRecords, setCorrectionRecords] = useState([]);
    const [loadingRecords, setLoadingRecords] = useState(false);
    const [loadingDocument, setLoadingDocument] = useState(false);
    const [documentPreviewRows, setDocumentPreviewRows] = useState([]);
    const [documentPreviewColumns, setDocumentPreviewColumns] = useState([]);

    var [showFileUploader, setShowFileUploader] = useState(false);
    var [fileUploaderDocuments, setFileUploaderDocuments] = useState([]);
    var DemarcationCorrectionDocumentTypes = [{
        id: 23,
        name: 'Demarcation Correction'
    },
    {
        id: 24,
        name: 'Demarcation Correction - Signed PDF'
    }]
    

    useEffect(() => {
        fetchAll();
    }, []);

    async function fetchAll() {
        setLoading(true);
        try {
            const data = await delimitationService.getAllCorrections();
            setRecords(data?.data ?? []);
        } catch {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to load demarcation corrections",
                life: 3000
            });
        } finally {
            setLoading(false);
        }
    }
    const numberTemplate = (rowData) => {
    return records.findIndex(
        r => r.delimitationCorrectionID === rowData.delimitationCorrectionID
    ) + 1;
};

    async function fetchCorrectionRecords(correctionID) {
        setLoadingRecords(true);
        try {
            const data = await delimitationService.getCorrectionRecords(correctionID);
            setCorrectionRecords(data?.data ?? []);
        } catch {
            toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to load correction records",
                life: 3000
            });
        } finally {
            setLoadingRecords(false);
        }
    }

    async function handleViewDocument(row) {
    setLoadingDocument(true);
    try {
        const response = await delimitationService.getCorrectionDocument(row.documentID);
        if (!response?.success) {
            toast.current.show({ severity: "error", detail: "Could not retrieve document.", life: 3000 });
            return;
        }
        var demarcationDocument = response.data;

        const base64 = response.data.binaryData;
        const binaryString = atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const ext = demarcationDocument.fileExtension?.toLowerCase();

        if (ext === "csv") {
            const text = new TextDecoder().decode(bytes);
            const lines = text.split("\n").filter(Boolean);
            const headers = lines[0].split(",").map((h) => h.trim());
            const rows = lines.slice(1).map((line) => {
                const cols = line.split(",");
                return headers.reduce((acc, h, i) => {
                    acc[h] = cols[i]?.trim() ?? "";
                    return acc;
                }, {});
            });
            setDocumentPreviewColumns(headers);
            setDocumentPreviewRows(rows);
            setSelectedCorrection(row);
            setShowDocumentDialog(true);
        } else {
            const blob = new Blob([bytes], { type: demarcationDocument.contentType });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = demarcationDocument.title;
            link.click();
            URL.revokeObjectURL(url);
        }
    } catch {
        toast.current.show({ severity: "error", detail: "Failed to load document.", life: 3000 });
    } finally {
        setLoadingDocument(false);
    }
}

    function resetForm() {
        setComment("");
        setSelectedFile(null);
        setFilePreviewRows([]);
        setFileBytes(null);
        setSelectedStructure(null);
        setFileUploaderDocuments([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
    }

    function handleFileChange(e) {
        const file = e.target.files[0];
        if (!file) return;
        setSelectedFile(file);
        const reader = new FileReader();
        reader.onload = (evt) => {
            setFileBytes(new Uint8Array(evt.target.result));
            if (file.name.endsWith(".csv")) {
                const text = new TextDecoder().decode(evt.target.result);
                const lines = text.split("\n").filter(Boolean);
                const headers = lines[0].split(",").map((h) => h.trim());
                const rows = lines.slice(1, 6).map((line) => {
                    const cols = line.split(",");
                    return headers.reduce((acc, h, i) => {
                        acc[h] = cols[i]?.trim() ?? "";
                        return acc;
                    }, {});
                });
                setFilePreviewRows(rows);
            } else {
                setFilePreviewRows([]);
            }
        };
        reader.readAsArrayBuffer(file);
    }

    function toBase64(bytes) {
        let binary = "";
        const chunkSize = 8192;
        for (let i = 0; i < bytes.length; i += chunkSize) {
            binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
        }
        return btoa(binary);
    }
        async function handleSubmit() {
        // if (!selectedFile || !fileBytes) {
        //     toast.current.show({ severity: "warn", detail: "Please select a file before submitting.", life: 3000 });
        //     return;
        // }
        if (!comment) {
            toast.current.show({ severity: "warn", detail: "Please provide a discription before submitting.", life: 3000 });
            return;
        }
        if (!selectedStructure) {
            toast.current.show({ severity: "warn", detail: "Please select a election structure.", life: 3000 });
            return;
        }

        setSubmitting(true);
        try {

            var docs = fileUploaderDocuments.map(doc => {
			var d = doc?.binaryData?.split(",");
			if (d?.length >= 2) {
				doc.binaryData = d[1];
			}
			return doc
		})
            const payload = {
                comment,
                demarcationTypeID: selectedStructure.id,
                // document: {
                //     title: selectedFile.name,
                //     fileExtension: selectedFile.name.split(".").pop(),
                //     contentType: selectedFile.type || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                //     binaryData: toBase64(fileBytes),
                //     documentTypeID: 1
                // }
                documents: docs
            };

            const response = await delimitationService.CreateDemarcationCorrection(payload);

            if (response?.success) {
                toast.current.show({ severity: "success", detail: "Demarcation corection request submitted.", life: 3000 });
                setShowCreateDialog(false);
                resetForm();
                fetchAll();
            } else {
                toast.current.show({ severity: "error", detail: response?.message ?? "Submission failed.", life: 3000 });
            }
        } catch {
            toast.current.show({ severity: "error", detail: "An error occurred while submitting.", life: 3000 });
        } finally {
            setSubmitting(false);
        }
    }

    const statusTemplate = (row) => (
        <Tag
            value={row.status === 1 ? "Approved" : row.status === 0 ? "Rejected" : "Pending"}
            severity={row.status === 1 ? "success" : row.status === 0 ? "danger" : "warning"}
        />
    );

    const dateTemplate = (row) => formatDateTime(row.dateCreated);
    const previewColumns = filePreviewRows.length > 0 ? Object.keys(filePreviewRows[0]) : [];

    const actionTemplate = (row) => (
        <div className="flex gap-2">
            <Button
                icon="pi pi-file"
                className="p-button-rounded p-button-sm p-button-outlined"
                tooltip={row.documentFileExtension?.toLowerCase() === "csv" ? "Preview document" : "Download document"}
                tooltipOptions={{ position: "top" }}
                loading={loadingDocument}
                onClick={() => handleViewDocument(row)}
            />
            <Button
                icon="pi pi-list"
                className="p-button-rounded p-button-sm p-button-outlined p-button-info"
                tooltip="View correction records"
                tooltipOptions={{ position: "top" }}
                onClick={() => {
                    setSelectedCorrection(row);
                    setShowRecordsDialog(true);
                    fetchCorrectionRecords(row.delimitationCorrectionID);
                }}
            />
        </div>
    );

    return (
        <div className="card" style={{ height: "100%" }}>
            <Toast ref={toast} />

            {/* Create Dialog */}
            <Dialog
                draggable={false}
                visible={showCreateDialog}
                style={{ width: "60%", minHeight: "400px" }}
                modal
                header={
                    <>
                        <i className="pi pi-plus-circle" style={{ marginRight: 8 }}></i>
                        New Election Structure Correction
                    </>
                }
                onHide={() => {
                    if (!submitting) {
                        setShowCreateDialog(false);
                        resetForm();
                    }
                }}
                footer={
                    <div>
                        <Button
                            icon="pi pi-send"
                            label="Submit correction"
                            className="p-button-success"
                            loading={submitting}
                            onClick={handleSubmit}
                            disabled={!selectedStructure || submitting || !comment}
                        />
                        <Button
                            icon="pi pi-times-circle"
                            label="Cancel"
                            className="p-button-danger ml-2"
                            disabled={submitting}
                            onClick={() => {
                                setShowCreateDialog(false);
                                resetForm();
                            }}
                        />
                    </div>
                }
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
                    <div>
                        <label style={{ fontWeight: 500, display: "block", marginBottom: 6 }}>
                            Select election structure <span style={{ color: "red" }}>*</span>
                        </label>
                        <Dropdown
                        
                            value={selectedStructure}
                            onChange={(e) => setSelectedStructure(e.value)}
                            options={lookUp?.demarcationTypes}
                            optionLabel="name"
                            placeholder="Select a structure"
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div>
                        <label style={{ fontWeight: 500, display: "block", marginBottom: 6 }}>
                            Description <span style={{ color: "red" }}>*</span>
                        </label>
                        <InputTextarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            rows={3}
                            style={{ width: "100%" }}
                            placeholder="Describe the corrections in this file"
                        />
                    </div>
                    {/* <div>
                        <label style={{ fontWeight: 500, display: "block", marginBottom: 6 }}>
                            Correction file <span style={{ color: "red" }}>*</span>
                        </label>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <Button
                                icon="pi pi-upload"
                                label="Browse file"
                                className="p-button-outlined"
                                onClick={() => fileInputRef.current?.click()}
                            />
                            {selectedFile && (
                                <span style={{ fontSize: 14, color: "var(--text-color-secondary)" }}>
                                    <i className="pi pi-file-excel" style={{ marginRight: 4 }}></i>
                                    {selectedFile.name}
                                    <span style={{ marginLeft: 8, color: "#888" }}>
                                        ({(selectedFile.size / 1024).toFixed(1)} KB)
                                    </span>
                                </span>
                            )}
                        </div>
                        <input
                            ref={fileInputRef}
                            type="file"
                            accept=".xlsx,.csv"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                        />
                    </div> */}
                    

                                            <div className="col-12">
                                                <GenericFileCapture
                                                    dontClearDocuments={true}
                                                    // refresh={refresh} setRefresh={setRefresh}
                                                    // key={JSON.stringify(showAddDialog)}
                                                    // extraAttributes={{
                                                    //     // "candidateID": selectedCanditate.candidateID,
                                                    //     "eventAgentID": selectedCanditate?.event?.eventID,
                                                    // }}
                                                    documentTypesLookUp={DemarcationCorrectionDocumentTypes} 
                                                    show={showFileUploader} 
                                                    setShow={setShowFileUploader}
                                                    setDocuments={setFileUploaderDocuments}
                                                    documents={fileUploaderDocuments}
                                                />
                                                <GenericUploadFileTable
                                                    header={<div className="col-12  lg:col-3 my-2">
                                                        <label htmlFor="description">
                                                            Upload Documents
                                                        </label>
                                                        <br />
                                                        <>
                                                            <Button
                                                                label={"Upload"}
                                                                onClick={() => setShowFileUploader(true)}
                                                                className="p-button-success"
                                                                icon={"pi pi-plus"}
                                                            />
                                                        </>
                                                    </div>}
                                                    setDocuments={setFileUploaderDocuments}
                                                    documents={fileUploaderDocuments}
                                                />
                                            </div>


                    {selectedFile && (
                        <div>
                            <label style={{ fontWeight: 500, display: "block", marginBottom: 6 }}>
                                Preview
                            </label>
                            {filePreviewRows.length > 0 ? (
                                <>
                                    <DataTable size="small" value={filePreviewRows} responsiveLayout="scroll" scrollable>
                                        {previewColumns.map((col) => (
                                            <Column key={col} field={col} header={col} />
                                        ))}
                                    </DataTable>
                                    <p style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Showing first 5 rows</p>
                                </>
                            ) : (
                                <div style={{
                                    background: "var(--surface-100)",
                                    border: "1px dashed var(--surface-400)",
                                    borderRadius: 8,
                                    padding: "1rem",
                                    textAlign: "center",
                                    color: "var(--text-color-secondary)",
                                    fontSize: 14
                                }}>
                                    <i className="pi pi-file-excel" style={{ fontSize: 24, display: "block", marginBottom: 8 }}></i>
                                    <strong>{selectedFile.name}</strong> selected.
                                    <br />
                                    Excel file preview is not available — the file will be processed on submission.
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Dialog>

            {/* CSV Document Preview Dialog */}
            <Dialog
                draggable={false}
                visible={showDocumentDialog}
                style={{ width: "80%", height: "80vh" }}
                modal
                header={
                    <>
                        <i className="pi pi-file" style={{ marginRight: 8 }}></i>
                        {`Document preview — ${selectedCorrection?.documentTitle}`}
                    </>
                }
                onHide={() => {
                    setShowDocumentDialog(false);
                    setDocumentPreviewRows([]);
                    setDocumentPreviewColumns([]);
                }}
                footer={
                    <Button
                        icon="pi pi-times-circle"
                        label="Close"
                        className="p-button-danger"
                        onClick={() => {
                            setShowDocumentDialog(false);
                            setDocumentPreviewRows([]);
                            setDocumentPreviewColumns([]);
                        }}
                    />
                }
            >
                <DataTable
                    size="small"
                    scrollable
                    value={documentPreviewRows}
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25]}
                    emptyMessage="No data found in document."
                    responsiveLayout="scroll"
                    resizableColumns
                >
                    {documentPreviewColumns.map((col) => (
                        <Column key={col} field={col} header={col} sortable />
                    ))}
                </DataTable>
            </Dialog>

            {/* Correction Records Dialog */}
            <Dialog
                draggable={false}
                visible={showRecordsDialog}
                style={{ width: "80%", height: "80vh" }}
                modal
                header={
                    <>
                        <i className="pi pi-list" style={{ marginRight: 8 }}></i>
                        {`Correction records [#${selectedCorrection?.delimitationCorrectionID}]`}
                    </>
                }
                onHide={() => {
                    setShowRecordsDialog(false);
                    setCorrectionRecords([]);
                }}
                footer={
                    <Button
                        icon="pi pi-times-circle"
                        label="Close"
                        className="p-button-danger"
                        onClick={() => {
                            setShowRecordsDialog(false);
                            setCorrectionRecords([]);
                        }}
                    />
                }
            >
                <DataTable
                    size="small"
                    scrollable
                    value={correctionRecords}
                    dataKey="delimitationCorrectionRecordID"
                    paginator
                    rows={10}
                    rowsPerPageOptions={[5, 10, 25]}
                    emptyMessage="No correction records found."
                    loading={loadingRecords}
                    responsiveLayout="scroll"
                    resizableColumns
                >
                    <Column field="oldCode" header="Old code" sortable />
                    <Column field="oldName" header="Old name" sortable />
                    <Column field="action" header="Action" sortable />
                    <Column field="newCode" header="New code" sortable />
                    <Column field="newName" header="New name" sortable />
                    {/* <Column field="electorsCount" header="Electors count" sortable /> */}
                </DataTable>
            </Dialog>

            {/* Page header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
                <h3 style={{ margin: 0 }}>Election Structure Correction</h3>
                <Button
                    icon="pi pi-plus"
                    label="New correction"
                    className="p-button-success"
                    onClick={() => setShowCreateDialog(true)}
                />
            </div>

            {/* Table */}
            <DataTable
                size="small"
                scrollable
                value={records}
                dataKey="delimitationCorrectionID"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 25]}
                className="datatable-responsive"
                emptyMessage="No demarcation correction found."
                loading={loading}
                resizableColumns
                columnResizeMode="expand"
            >
                {/* <Column field="delimitationCorrectionID" header="No" style={{ width: 80 }} sortable /> */}
                <Column
                    header="No"
                    body={numberTemplate}
                    style={{ width: 80 }}
                />
                <Column field="comment" header="Description" sortable />
                <Column field="demarcationTypeName" header="Structure" sortable />
                {/* <Column header="Status" body={statusTemplate} sortable /> */}
                <Column header="Created date" body={dateTemplate} sortable />
                <Column field="createdByName" header="Created by" sortable />
                <Column header="Actions" body={actionTemplate} style={{ width: 110 }} />
            </DataTable>
        </div>
    );
};

export default DelimitationCorrectionManagement;